<!-- Main Layout with sticky header and scrollable content -->
<div class="flex flex-col min-h-screen">
  <!-- Header - Sticky Navigation -->
  <app-header [isScrolled]="isScrolled"></app-header>

  <!-- Main Content -->
  <main class="flex-grow">
    <!-- Hero Section -->
    <app-hero data-aos="fade-up"></app-hero>

    <!-- Live Demo Section -->
    <div class="bg-dark-blue" id="demo">
      <div class="container mx-auto px-4">
        <app-live-demo data-aos="fade-up" data-aos-delay="100"></app-live-demo>
      </div>
    </div>

    <!-- How It Works Section -->
    <div class="bg-charcoal" id="how-it-works">
      <div class="container mx-auto px-4">
        <app-how-it-works data-aos="fade-up" data-aos-delay="100"></app-how-it-works>
      </div>
    </div>

    <!-- Pricing Section -->
    <div class="bg-dark-blue" id="pricing">
      <div class="container mx-auto px-4">
        <app-pricing data-aos="fade-up" data-aos-delay="100"></app-pricing>
      </div>
    </div>

    <!-- Why Us Section -->
    <div class="bg-charcoal" id="why-us">
      <div class="container mx-auto px-4">
        <app-why-us data-aos="fade-up" data-aos-delay="100"></app-why-us>
      </div>
    </div>

    <!-- Song Hub Section -->
    <div class="bg-dark-blue" id="song-hub">
      <div class="container mx-auto px-4">
        <app-a-song-hub data-aos="fade-up" data-aos-delay="100"></app-a-song-hub>
      </div>
    </div>

    <!-- Newsletter Signup Section - disabled until backend is ready -->
    <!-- <section class="bg-charcoal" id="newsletter">
      <app-newsletter-signup data-aos="fade-up" data-aos-delay="100"></app-newsletter-signup>
    </section> -->

    <!-- Final CTA Section -->
    <section class="bg-gradient-to-r from-electric-blue to-magenta px-4" aria-labelledby="cta-heading">
      <div class="container mx-auto text-center">
        <h2 id="cta-heading" class="text-4xl font-bold mb-6" data-aos="fade-up">Ready to Revolutionize Your Visual Sound tracking?</h2>
        <p class="text-white text-xl max-w-3xl mx-auto mb-8" data-aos="fade-up" data-aos-delay="100">Unlock the power of
          MyPart AI. Integrate intelligent song matching into your platform and transform how visual content connects
          with audiences.</p>
        <button (click)="scheduleDemo()" class="btn bg-white text-dark-blue hover:bg-opacity-90 hover:shadow-lg"
                data-aos="fade-up" data-aos-delay="200">Schedule a Demo
        </button>
      </div>
    </section>
  </main>

  <!-- Footer -->
  <app-footer data-aos="fade-up" data-aos-delay="100"></app-footer>
</div>

<!-- Modal Manager - Handles all application modals -->
<app-modal-manager></app-modal-manager>
